import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeBanner from '../../component/slidercomponent/SliderHomeBanner';


const HomeBanner = () => {
    return (
        <>

            <div className="hero-section">
                <div className="hero-slider owl-carousel owl-loaded owl-drag">
                    <div className="owl-stage-outer">
                        <SliderHomeBanner />
                    </div>
                </div>
            </div>



            














        </>
    )
}

export default HomeBanner